import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {GridList, GridTile} from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import Paper from 'material-ui/Paper';
import withActionOnMount from './shared/ActionOnMount';
import { fetchServices } from '../redux/actions';

const Paypal = () => (
    <Grid fluid>
        <Row>
            <Col xs={12}>
                <Row center="xs">
                    <Paper>
                        <Col xs={12}>
                            <h1>Now Accepting Payment Through Paypal</h1>
                            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top"><input name="cmd" type="hidden" value="_s-xclick" />
                                <input name="hosted_button_id" type="hidden" value="YCKWLMF2KJGFJ" />
                                <input alt="PayPal - The safer, easier way to pay online!" name="submit" src="https://www.paypalobjects.com/en_US/i/btn/btn_paynowCC_LG.gif" type="image" />
                                <img src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" alt="" width="1" height="1" border="0" />
                            </form>
                        </Col>
                    </Paper>
                </Row>
            </Col>
        </Row>
    </Grid>
);

export default Paypal;


// WEBPACK FOOTER //
// ./src/components/Paypal.js